import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import MsbTable from "./MsbTable";
import MsbTableHeader from "./MsbTableHeader";
// import MsbTableManagement from "./MsbTableManagement";
import * as ruleService from "../ruleService";
import PaginationManager from "../../view/PaginationManager";
import { TableContext } from "../../index";
import { debug } from "../../utils";


function MsbTableSection(props) {

    const history = useHistory();

    const initTableConfig = {
        selected: [],
        rules: [],
        isLoading: true
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
            {/* <MsbTableManagement /> */}
            <div className="container-fluid" key={history.location}>
                <div className="row">
                    <div className="col-12">
                        <div className="card oct_analysis-card-v2">
                            <MsbTableHeader />
                            <div className="card-body">
                                <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <MsbTable />
                                            <PaginationManager getPage={ruleService.ruleListPageable} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TableContext.Provider>
    )
}

export default MsbTableSection;
